import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Bell, Check, CheckCheck } from "lucide-react";
import { PushSettingsCard } from "@/components/PushNotifications";

export default function Notifications() {
  const [items, setItems] = useState([]);

  const load = async () => {
    const { data } = await api.get("/notifications");
    setItems(data);
  };
  useEffect(() => { load(); }, []);

  const markOne = async (id) => { await api.patch(`/notifications/${id}/read`); load(); };
  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <div className="space-y-6 max-w-3xl mx-auto" data-testid="notifications-page">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-display text-3xl font-bold tracking-tight text-slate-900">Notifications</h1>
          <p className="text-slate-500 mt-1">Restez informé de tout ce qui se passe.</p>
        </div>
        <button data-testid="notif-mark-all" onClick={markAll}
                className="flex items-center gap-2 px-3 py-2 rounded-xl bg-white border border-slate-200 hover:bg-slate-50 text-sm font-semibold">
          <CheckCheck className="w-4 h-4"/> Tout marquer comme lu
        </button>
      </div>

      <PushSettingsCard/>

      <div className="space-y-2">
        {items.map((n) => (
          <div key={n.id} data-testid={`notif-${n.id}`}
               className={`bg-white border border-slate-200 rounded-2xl p-4 flex items-center gap-4 ${n.read ? "opacity-70" : ""}`}>
            <div className={`w-10 h-10 rounded-xl grid place-items-center ${n.read ? "bg-slate-100 text-slate-400" : "bg-indigo-50 text-indigo-600"}`}>
              <Bell className="w-5 h-5"/>
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium text-slate-900">{n.message}</div>
              <div className="text-xs text-slate-400 mt-0.5">{new Date(n.created_at).toLocaleString("fr-FR")}</div>
            </div>
            {!n.read && (
              <button data-testid={`notif-read-${n.id}`} onClick={() => markOne(n.id)}
                      className="w-8 h-8 grid place-items-center rounded-lg text-indigo-600 hover:bg-indigo-50"><Check className="w-4 h-4"/></button>
            )}
          </div>
        ))}
        {items.length === 0 && (
          <div className="bg-white border border-slate-200 rounded-2xl py-16 text-center text-slate-400">Aucune notification.</div>
        )}
      </div>
    </div>
  );
}
